// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d60777e2","453":"f979c475"}[chunkId] + ".chunk.js";
};